import { apiGatewayUrl } from '../../config/environment';

export const LOGIN_REDIRECT_URL = 'login_redirect_url';

export const login = (language = 'en') => {
  const url = window.location.pathname;
  if (url !== '/' && !url.includes('redirect')) {
    localStorage.setItem(LOGIN_REDIRECT_URL, url);
  }

  window.open(`${apiGatewayUrl}/authenticate?language=${language}`, '_self');
};
